<template>
  <user-header></user-header>
  <breadcrumb :title="title" :text="text" :text1="text1" />
  <user-tabset></user-tabset>
  <div class="content court-bg">
    <div class="container">
      <!-- Sort By -->
      <div class="row">
        <div class="col-lg-12">
          <div class="sortby-section court-sortby-section">
            <div class="sorting-info">
              <div class="row d-flex align-items-center">
                <div class="col-xl-7 col-lg-7 col-sm-12 col-12">
                  <booking-tabset></booking-tabset>
                </div>
                <div class="col-xl-5 col-lg-5 col-sm-12 col-12">
                  <div class="sortby-filter-group court-sortby">
                    <div class="sortbyset week-bg">
                      <div class="sorting-select">
                        <vue-select
                          :options="Week"
                          id="thisweekfive"
                          placeholder="This Week"
                        />
                      </div>
                    </div>
                    <div class="sortbyset">
                      <span class="sortbytitle">Sort By</span>
                      <div class="sorting-select">
                        <vue-select
                          :options="Relevance"
                          id="relevancefive"
                          placeholder="Relevance"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Sort By -->

      <div class="row">
        <div class="col-sm-12">
          <div class="court-tab-content">
            <div class="card card-tableset">
              <div class="card-body">
                <div class="coache-head-blk">
                  <div class="row align-items-center">
                    <div class="col-md-5">
                      <div class="court-table-head">
                        <h4>My Bookings</h4>
                        <p>Track and manage your cancelled court bookings</p>
                      </div>
                    </div>
                    <div class="col-md-7">
                      <div class="table-search-top">
                        <div id="tablefilter">
                          <div class="dataTables_filter">
                            <label> 
                                <input type="search" class="form-control form-control-sm" placeholder="Search" aria-controls="DataTables_Table_0">
                            </label>
                          </div>
                        </div>
                        <div class="request-coach-list">
                          <div class="card-header-btns">
                            <nav>
                              <div class="nav nav-tabs" role="tablist">
                                <button
                                  class="nav-link active"
                                  id="nav-Recent-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#nav-Recent"
                                  type="button"
                                  role="tab"
                                  aria-controls="nav-Recent"
                                  aria-selected="true"
                                >
                                  Courts
                                </button>
                                <button
                                  class="nav-link"
                                  id="nav-RecentCoaching-tab"
                                  data-bs-toggle="tab"
                                  data-bs-target="#nav-RecentCoaching"
                                  type="button"
                                  role="tab"
                                  aria-controls="nav-RecentCoaching"
                                  aria-selected="false"
                                >
                                  Coaches
                                </button>
                              </div>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-content">
                  <cancelled-court></cancelled-court>
                  <cancelled-coaches></cancelled-coaches>
                </div>
              </div>
            </div>
            <div class="tab-footer">
              <div class="row">
                <div class="col-md-6">
                  <div id="tablelength">
                    <div class="dataTables_length" id="DataTables_Table_0_length">
                      <label>Show
                        <select class="custom-select custom-select-sm form-control form-control-sm">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="-1">All</option>
                        </select>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div id="tablepage">
                    <div class="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                      <ul class="pagination">
                        <li class="paginate_button page-item previous disabled" id="DataTables_Table_0_previous"><a
                            href="javascript:void(0);" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0"
                            class="page-link"><i class="feather-chevrons-left"></i></a></li>
                        <li class="paginate_button page-item active"><a href="javascript:void(0);"
                            aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0" class="page-link">1</a></li>
                        <li class="paginate_button page-item next disabled" id="DataTables_Table_0_next"><a
                            href="javascript:void(0);" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0"
                            class="page-link"><i class="feather-chevrons-right"></i></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
  <user-cancelled-modal></user-cancelled-modal>
</template>
<script>
export default {
  data() {
    return {
      title: "User Bookings",
      text: "Home",
      text1: "User Bookings",
      Week: ["This Week", "One Day"],
      Relevance: ["Relevance", "Price"],
    };
  },
};
</script>
